import { FlightBookingDetails } from "@apac/components/checkout";
import type { TripDetailsV2 } from "@b2bportal/air-shopping-api";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { Icon } from "@b2bportal/core-ui";
import { CoreFlightSteps, NavigationFlow } from "@b2bportal/core-utilities";
import {
  FlightSelectors,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import { MixedCabinDisclaimer } from "@tenant/flights";
import styles from "./styles.module.scss";

export const ConnectedTripDetails = ({
  showActionLinks,
}: {
  showActionLinks?: boolean;
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "TripSummaryReview");

  const goToStep = NavigationFlow.useGoToStep();

  //TODO: After fixing state types as they are not correct right now.
  const tripDetails = useSelector(
    FlightSelectors.getTripDetails
  ) as any as TripDetailsV2;
  const selectedFareId = useSelector(FlightSelectors.getSelectedFareId);
  const fareDetails = tripDetails?.fareDetails.find(
    (fare) => fare.id === selectedFareId
  );

  return (
    <div className={block}>
      <FlightBookingDetails
        tripDetails={tripDetails}
        fareDetails={fareDetails}
        renderSliceFooter={(fareSlice) => (
          <MixedCabinDisclaimer fareSlice={fareSlice} />
        )}
      />

      {showActionLinks && (
        <button
          className={cn("edit-button")}
          onClick={() => goToStep(CoreFlightSteps.DEPARTURE)}
        >
          <Icon iconName={IconNameEnum.edit} /> <span>{t("edit")}</span>
        </button>
      )}
    </div>
  );
};
